import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter as Router } from 'react-router-dom'
import 'typeface-roboto';
 

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>

        <style type="text/css" media="print">{"@page {size: portrait; margin: 0 0 0 0}"}</style>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
            <Router basename="/WsWebAppWellcomplete/build" forceRefresh={true}>
                <CookiesProvider>
                    <App />
                </CookiesProvider>
            </Router>

        </PersistGate>
    </Provider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
